<template>
  <div
    ref="cardRef"
    :class="{
      'bg-cover bg-center after:absolute after:inset-0 after:bg-white/75 after:backdrop-blur sm:bg-fixed':
        fixed,
    }"
    class="relative mx-auto grid p-[clamp(16px,5vw,92px)] text-[clamp(18px,2vw,22px)] font-medium"
    :style="{ backgroundImage: background ? `url(${background})` : '' }"
  >
    <div
      class="z-1 mx-auto grid rounded-2xl transition-all duration-700 lg:min-h-[600px] lg:max-w-screen-xl lg:grid-cols-2"
      :class="
        isVisible
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 translate-y-24 scale-75'
      "
    >
      <div
        class="z-1 col-auto -mt-4 grid items-center gap-[clamp(16px,2vw,24px)] rounded-2xl bg-white p-[clamp(16px,5vw,64px)] shadow-2xl lg:col-[1] lg:-mr-4 lg:-mt-3 lg:h-full"
        :class="{
          'lg:col-[2] lg:-ml-4 lg:-mt-3': flipped,
        }"
      >
        <h2 class="home-title text-[clamp(24px,3vw,42px)] font-bold">
          {{ title }}
        </h2>

        <slot />

        <slot name="button" />
      </div>

      <div
        class="row-[1] h-full min-h-[400px] rounded-t-2xl bg-cover bg-center lg:mt-3 lg:min-h-[auto] lg:rounded-2xl"
        :class="flipped ? 'lg:col-[1]' : 'lg:col-[2]'"
        :style="{ backgroundImage: src ? `url(${src})` : '' }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, onBeforeMount, ref } from 'vue';

withDefaults(
  defineProps<{
    background?: string;
    fixed?: boolean;
    flipped?: boolean;
    src?: string;
    title?: string;
  }>(),
  {
    background: '',
    fixed: false,
    flipped: false,
    src: '',
    title: '',
  },
);

const cardRef = ref<HTMLDivElement | null>(null);

const observer = ref<IntersectionObserver | null>(null);

const isVisible = ref(false);

const onElementObserved = (entries: IntersectionObserverEntry[]) => {
  entries.forEach(({ target, isIntersecting }) => {
    if (!isIntersecting) {
      return;
    }

    observer.value?.unobserve(target);

    isVisible.value = true;
  });
};

onBeforeMount(() => {
  observer.value = new IntersectionObserver(onElementObserved, {
    root: cardRef.value,
    threshold: 0.1,
  });
});

onMounted(() => {
  observer.value?.observe(cardRef.value as HTMLDivElement);
});

onBeforeUnmount(() => {
  observer.value?.unobserve(cardRef.value as HTMLDivElement);
});
</script>
